import { login } from '@urls';
import { useAppContext } from '@contexts/AppContext';

import { useViewerQuery } from './graphql.v5.generated';

type Viewer = {
  id: number
};

type Result = {
  loading: boolean,
  viewer: Viewer | null
};

export const useViewer = (required = false): Result => {
  const { isBot } = useAppContext();
  const skip = isBot;
  const { data, loading } = useViewerQuery({
    context: {
      v5: true,
    },
    skip,
  });

  let viewer = null;

  if (data?.me) {
    viewer = {
      id: data.me.id,
    };
  }

  if (!skip && !loading && !data?.me && required) {
    const searchParams = new URLSearchParams({ next: location.href });

    if (!location.pathname.startsWith(login)) {
      location.href = `${login}?${searchParams.toString()}`;
    }
  }

  return {
    viewer,
    loading,
  };
};
